import { __extends } from "tslib";
import { UpdateGcmChannelRequest, UpdateGcmChannelResponse } from "../models/index";
import { deserializeAws_restJson1UpdateGcmChannelCommand, serializeAws_restJson1UpdateGcmChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateGcmChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateGcmChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateGcmChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateGcmChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateGcmChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateGcmChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateGcmChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateGcmChannelCommand(input, context);
    };
    UpdateGcmChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateGcmChannelCommand(output, context);
    };
    return UpdateGcmChannelCommand;
}($Command));
export { UpdateGcmChannelCommand };
//# sourceMappingURL=UpdateGcmChannelCommand.js.map